<template>
  <div>
    <div class="live-table">
    	<div class="live-top-btn">
    		<ul>
    			<li v-for="(item,index) in navlist" :key="index"><a @click="pagechange(item)" href="javascript:;" :class="{'option-two-state' : item.iscur}">{{item.name}}</a></li>
    		</ul>
    	</div>
    </div>


    <div class="live-table-content" v-loading="loading">
      	<ul>
      		<li v-for="(item,index) in livelist" :key="index" @click="todetail(item)">
      			<a href="javascript:;">
      				<div class="live-cont">
      					<div class="live-title">{{item.liveName}}</div>
      					<div class="live-time-table">
                  <img src="../../assets/img/clock_live.png">
                  <div class="live-time-text">{{item.startTime}}</div>
                </div>
      					<div class="live-btn">
      						<div class="live-left">
      							<img :src="item.teacherImg" >
      							<div class="live-left-name">{{item.teacherName}}</div>
      						</div>
      						<div class="live-right">
      							<div :class="item.classname">{{item.liveStatusname}}</div>
      							<div v-if="item.liveStatus == 2" class="live-right-number">{{item.watchPeople}}人观看</div>
      						</div>
      					</div>
      				</div>
      			</a>
      		</li>
          <br style="clear:both" />
        </ul>
        <Nothing v-show="livelist.length == 0"></Nothing>
    </div>

    <div style="text-align: center;" v-show="listlength">
      <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
    </div>

  </div>
</template>

<script>
  import {ApiGetlivelist} from '../../net/course/index.js'
  import Nothing from '../../common/nothing.vue'
  import {getLiveUrl} from '../../untils/common.js'
  export default {
    data: function () {
      return {
        param : {},
        currentPage3 : 1,
        pageSize : 20,
        total : 20,
        pageNum : 1,
        livelist : [],
        loading : false,
        username: '',
        realName: '',
        classname :{
          1 : 'live-right-btngrey',
          2 : 'live-right-btnred',
          3 : 'live-right-btngreen',
          4 : 'live-right-btngrey'
        },
        liveStatusname :{
          1 : '即将开始',
          2 : '正在直播',
          3 : '查看回放',
          4 : '回放生成中'
        },
        navlist :[
          {
            name : '全部直播',
            iscur : true,
            type : 0
          },
          {
            name : '正在直播',
            iscur : false,
            type : 1
          },
          {
            name : '直播预告',
            iscur : false,
            type : 2
          },
          {
            name : '直播回放',
            iscur : false,
            type : 3
          }
        ]
      }
    },
    components: {
      Nothing
    },
    mounted() {
     this.liveType = 0;
     this.getLive();
    },
    computed: {
      listlength() {
        return this.livelist.length > 0
      }
    },
    methods: {
      pagechange(item){
        this.liveType = item.type;
        this.getLive()
        this.navlist  = this.navlist.map(nav =>{
          return {...nav , iscur : item.name == nav.name}
        })
      },
      handleCurrentChange(index){
        this.pageNum = index;
        this.getLive();
      },
      getLive(){
        this.loading = true
        const params= {
          liveType : this.liveType,
          pageNum	: this.pageNum,
          pageSize : 20,
          platform : 'pc'
        }
        ApiGetlivelist(params).then(res=>{
          if(res.code == 200){
            this.total = res.pc.total

            this.livelist = res.pc.details.map(item=>{
              if (item.liveStatus==3 && !item.playUrl) {
                item.liveStatus = 4
              }
              return {
                  ...item,
                  teacherImg: item.teacherImg || `http://statics.sgn.7east.cn/photo/20201207172318.png`,
                  classname: this.classname[item.liveStatus],
                  liveStatusname:this.liveStatusname[item.liveStatus]
                }
            })

          }
          this.loading = false
        })
      },
      todetail(item){
        if(!this.$store.state.isLogin){
          this.$store.commit('showLogin', true)
          return
        }
        if(item.liveStatus == 2){
          const liveUrl = getLiveUrl(item.classId)
          // console.log('liveUrl', liveUrl)
          window.open(liveUrl, '_blank')
        }else{
          if(item.playUrl&&item.liveStatus==3){
            const { href } = this.$router.resolve({
                  path: `liveBackPlayer`,
                  query:{lid : item.id}
                });
            window.open(href, '_blank');
          }else{

          }
        }
      },
    },
  }
</script>

<style scoped>
  body{
  	margin:0;
  	padding:0;
  	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB',  'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji',  'Segoe UI Emoji', 'Segoe UI Symbol';
  	background-color: #f5f6f7;
  	text-decoration: none;
  }
  .live-table{
  	width: 1140px;
  	margin:0 auto;
  }
  .live-table ul{
  	margin:0;
  	padding:0;
    float: left;
  }
  .live-table ul li{
  	list-style-type: none;
  	float: left;
  	margin-right: 24px;
  	height: 32px;
  }
  .live-table ul li a{
  	padding: 8px 16px;
  	text-decoration: none;
  	color: #fff;
  	border-radius: 16px;
  	line-height: 16px;
  	float: left;
  	color: #454545;
  }
  .live-table ul li a.option-two-state{
  	background-color: #0AAC50;
  	color: #fff;
  }
  .live-table ul li a:hover{
  	background-color: #0AAC50;
  	color: #fff;
  }
  .live-top-btn{
  	width: 1140px;
  	margin:0 auto;
  	margin-top: 30px;
  	height: 32px;
  }
  .live-table-content{
  	width: 1140px;
  	margin:0 auto;
  	margin-top: 30px;
  }
  .live-table-content ul{
  	margin:0 ;
  	padding:0;
  }
  .live-table-content ul li{
  list-style-type: none;
  float: left;
  margin-right: 24px;
  margin-bottom: 24px;
  }
  .live-table-content  ul li:nth-child(3n) {margin-right:0;}
  .live-cont{
  	width: 364px;
  	background:#fff;
  	float: left;
  	border-radius: 6px;
  }
  .live-title{
  	margin-top: 30px;
  	margin-left: 15px;
  	margin-right:15px;
  	font-size: 18px;
  	font-weight: bold;
  	color: #252525;
  	overflow: hidden;
  	text-overflow:ellipsis;
  	white-space: nowrap;
  }
  .live-time-table{
  	height: 14px;
  	margin-top: 15px;
  	float: left;
  	width: 100%;
  }
  .live-time-table img{
  	width: 16px;
  	height: 16px;
  	border:none;
  	float: left;
  	margin-left: 15px;
  	margin-right: 10px;;
  }
  .live-time-text{
  	font-size: 16px;
  	float:left;
  	line-height: 16px;
  	color: #7F7F7F;
  }
  .live-left img{
  	width: 36px;
  	height: 36px;
    border-radius: 50%;
  }
  .live-btn{
  	margin-top: 30px;
  	float: left;
  	width: 100%;
  }
  .live-left{
  	margin-left: 15px;
  	margin-bottom: 30px;
  	float: left;
  }
  .live-left-name{
  	font-size: 14px;
  	color: #7f7f7f;
  	margin-top: 5px;
  }
  .live-table-content ul li a{
  	text-decoration: none;
  }
  .live-right{
  	float: right;
  	margin-right: 15px;
  }
  .live-right-btnred{
  	width: 100px;
  	height: 36px;
  	border-radius: 36px;
  	background: #FF1010;
  	color: #fff;
  	text-align: center;
  	line-height: 36px;
  }
  .live-right-number{
  	font-size: 14px;
  	color: #7F7F7F;
  	margin-top: 5px;
    text-align: center;
  }
  .live-right-btngrey{
  	width: 100px;
  	height: 36px;
  	border-radius: 36px;
  	background: #e5e5e5;
  	color: #7f7f7f;
  	text-align: center;
  	line-height: 36px;
  }
  .live-right-btngreen{
  	width: 100px;
  	height: 36px;
  	border-radius: 36px;
  	background: #00B54F;
  	color: #fff;
  	text-align: center;
  	line-height: 36px;
  }
  .noThing{
    width: 100%;
    height: 272px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/LiveCourse/LiveCourse.vue